<template>
  <h3>
    Consulting, service provision, software developpement and Research
  </h3>
  <hr />
  <div class="content">
    Desktop software, mobile applications or Artificial Intelligence-based solutions, make it happen with BComputd.
  </div>
</template>

<script>
export default {
  name: "Home",

  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 5% 0;
}
</style>
